import { Params } from '@angular/router';
import { MaintenanceComponentTabReferrer } from '../enums/maintenance-component-tab-referrer.enum';
import { getLinkToMaintenanceComponent } from './route-helpers';

export function getMaintenanceComponentReturnTarget(
  componentId: string,
  { referrerType, referrerComponentId }: Params
): { url: string; queryParams: Params } {
  const activeTab = Object.values(MaintenanceComponentTabReferrer).includes(referrerType)
    ? referrerType
    : null;
  return {
    url: getLinkToMaintenanceComponent(referrerComponentId ?? componentId),
    queryParams: { activeTab },
  };
}
